export enum NutsTypeEnum {
    Elektriciteit,
    Gas
}